import { Link } from 'react-router-dom';
import { Phone, Mail, ArrowRight } from 'lucide-react';

const Footer = () => {
  const services = [
    { name: 'Private Charter', path: '/services/private-charter' },
    { name: 'Group Charter', path: '/services/group-charter' },
    { name: 'Air Cargo', path: '/services/air-cargo' },
    { name: 'Special Missions', path: '/services/special-missions' },
    { name: 'On-Demand Fleet', path: '/fleet' },
  ];

  const quickLinks = [
    { name: 'About Us', path: '/about' },
    { name: 'Singapore', path: '/singapore' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <footer className="bg-slate-900 text-white">
      
      {/* Main Footer */}
      <div className="container-padding py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_singapore-air-v2/artifacts/au4hsghu_SACLogo-02.png"
              alt="Singapore Air Charter"
              className="h-20 md:h-28 lg:h-32 w-auto mb-6"
            />

            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Founded by a management team of experienced Singapore based aviation professionals, Singapore Air Charter provides tailored aviation solutions across private charter, group charter, cargo and special operations.
            </p>

            <div className="gold-line"></div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-medium tracking-widest uppercase text-slate-400 mb-6">
              Our Services
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.name}>
                  <Link
                    to={service.path}
                    className="text-slate-300 hover:text-blue-500 transition-colors text-sm flex items-center gap-2 group"
                  >
                    <ArrowRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-medium tracking-widest uppercase text-slate-400 mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-slate-300 hover:text-blue-500 transition-colors text-sm flex items-center gap-2 group"
                  >
                    <ArrowRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-medium tracking-widest uppercase text-slate-400 mb-6">
              Contact Us
            </h4>

            <ul className="space-y-4">
              <li>
                <a
                  href="tel:+6581888023"
                  className="flex items-start gap-3 text-slate-300 hover:text-blue-500 transition-colors"
                >
                  <Phone className="w-4 h-4 mt-1" />
                  <div>
                    <span className="text-xs text-slate-500 block">Main Line</span>
                    <span className="text-sm">+65 8188 8023</span>
                  </div>
                </a>
              </li>

              <li>
  <a
    href="mailto:charter@singaporeaircharter.com"
    className="flex items-start gap-3 text-slate-300 hover:text-blue-500 transition-colors"
  >
    <Mail className="w-4 h-4 mt-1" />
    <div>
      <span className="text-xs text-slate-500 block">Charter Enquiries</span>
      <span className="text-sm">charter@singaporeaircharter.com</span>
    </div>
  </a>
</li>
        
            </ul>

          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-slate-800">
        <div className="container-padding py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Singapore Air Charter. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm">
            Aviation Excellence Since 2010
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
